module.exports = __webpack_public_path__ + "media/images/report-abuse-4930963c4dda1b90da743a5acbd5278a.png";